import axios from 'axios'
import { Country } from 'src/core/models'

export async function getCountryListAPI(): Promise<Country[]> {
  const url = `/api/v1/countries/?page_size=9999`
  const { data } = await axios.get<{ results: Country[] }>(url)
  return data.results
}
